import axios, { type AxiosInstance } from 'axios';

/**
 * The one Axios instance every generated call flows through. Interceptor registration
 * (including baseURL resolution) lives only in `interceptors.ts`: their relative order is
 * load-bearing, and splitting registration across modules is how that order breaks.
 */
export const apiClient: AxiosInstance = axios.create({
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
});
